import { decryptRequest } from "../utils/encryptdecryptrequest";
import { axios_instance, updateAxiosHeaders } from "./axios_instance";

const getCsrfToken = async () => {
  let csrfToken = null;

  try {
    localStorage.removeItem("csrfToken");
    sessionStorage.removeItem("csrfToken");
    const res = await axios_instance({
      url: "rbac/getCsrfToken",
      method: "GET",
    });

    if (res && res.status === 200) {
      const resData = decryptRequest(res.data.resData);

      if (resData?.csrfToken.length) {
        csrfToken = decryptRequest(resData.csrfToken);
        localStorage.setItem("csrfToken", csrfToken);
        sessionStorage.setItem("csrfToken", csrfToken);
        updateAxiosHeaders();
      }
    }
  } catch (error) {
    console.log("Error:", error);
  } finally {
    return csrfToken;
  }
};
export { getCsrfToken };
